import { ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonGroup } from '@ardoq/button';
import { header1, text1 } from '@ardoq/typography';

import { DoqFace } from './DoqFace';
import { DoqSize, DoqType } from './types';

import { Stack, FlexBox } from '@ardoq/layout';

const Wrapper = styled.div`
  max-width: 650px;
`;

const SvgWrapper = styled.div`
  flex-shrink: 0;
`;

const Title = styled.h2`
  ${header1}

  margin: 0;
`;

const Message = styled.div`
  ${text1}
`;

export type DoqWithSideContentProps = {
  doqType: DoqType;
  title?: string;
  children?: ReactNode;
  message?: string;
  buttons?: ReactNode;
};

export const DoqWithSideContent = ({
  doqType,
  title,
  children,
  message,
  buttons,
  ...rest
}: DoqWithSideContentProps) => {
  return (
    <FlexBox justify="center" gap="medium">
      <Wrapper {...rest}>
        <FlexBox align="center" gap="xlarge">
          <SvgWrapper>
            <DoqFace doqType={doqType} doqSize={DoqSize.PETIT_MEDIUM} />
          </SvgWrapper>
          <Stack gap="medium">
            {title && <Title>{title}</Title>}
            <Message>
              {message}
              {children}
            </Message>
            {buttons && <ButtonGroup>{buttons}</ButtonGroup>}
          </Stack>
        </FlexBox>
      </Wrapper>
    </FlexBox>
  );
};
